<template>
  <ul class="self-start bg-gray-10 p-4">
    <li>
      <trek-button
        v-show="!etaTab"
        button
        text
        icon="get_app"
        :disabled="backorderDownloading"
        qaid="allocatedBackorder-download-backorders"
        @click="downloadBackorders"
      >
        <span v-html="bp('download')"></span>
      </trek-button>
    </li>
    <li>
      <trek-button
        button
        text
        icon="get_app"
        :disabled="etaDownloading"
        qaid="allocatedBackorder-download-eta-changes"
        @click="downloadEtaReport"
      >
        <span v-html="bp('etaChanges')"></span>
      </trek-button>
    </li>
  </ul>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import DownloadBackorders from '@/components/containers/my-account/mixins/download-backorders';
import DownloadEtaReport from '@/components/containers/my-account/mixins/download-eta-report';
export default {
  name: 'AllocatedBackorderHistoryReports',
  components: {
    TrekButton,
  },
  mixins: [DownloadBackorders, DownloadEtaReport],
  props: {
    baseProperties: {
      type: Array,
      default: undefined,
    },
    hideUnallocated: {
      type: Boolean,
      default: false,
    },
    hideLinesWithoutComments: {
      type: Boolean,
      default: false,
    },
    descriptionSearchTerm: {
      type: String,
      default: '',
    },
    skuSearchTerm: {
      type: String,
      default: '',
    },
    orderNumberSearchTerm: {
      type: String,
      default: '',
    },
    customerPoSearchTerm: {
      type: String,
      default: '',
    },
    configSortByForUrl: {
      type: String,
      default: '',
    },
    hidePreseason: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: String,
      default: '',
    },
    etaTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      downloadTimeout: null,
      backorderDownloading: false,
      etaDownloading: false,
    };
  },
};
</script>
